import axios from './index';

// 获取账户信息
export const fetchAccountInfo = () => {
  return axios.get('/api/login/getLoginInfo');
};

// 账户退出
export const logout = () => {
  return axios.get('/api/logout');
};

// 获取城市信息
export const fetchCityList = () => {
  return axios.get('/api/common/city');
};

// 获取城市信息 V2
export const fetchCityListV2 = (cityName) => {
  return axios.get('/api/common/cityV2?cityName=' + cityName);
};

// 获取行业+岗位信息（树状）
export const fetchCategoryTree = () => {
  return axios.get('/api/common/homePage/category/tree');
};

// 获取行业+岗位信息（列表）
export const fetchCategoryList = () => {
  return axios.get('/api/common/homePage/category/jobIndustrySkill');
};

// 上传功能 (onProgress 可选，回调参数 0-100)
export const upload = (data, onProgress) => {
  return axios.post('/api/common/upload', data, {
    onUploadProgress: (e) => {
      if (onProgress && e.total > 0) {
        onProgress(Math.round((e.loaded * 100) / e.total));
      }
    },
  });
};

// 上传视频功能（旧链路，服务端中转）
export const uploadVideo = (data) => {
  return axios.post('/api/common/uploadVideoV2', data);
};

// 获取上传视频进度
export const fetchUploadVideoProgress = (uploadId) => {
  return axios.get('/api/common/uploadVideoV2/progress/' + uploadId);
};

export const createVodUpload = (data) => {
  return axios.post('/api/common/vod/createUpload', data);
};

export const completeVodUpload = (data) => {
  return axios.post('/api/common/vod/complete', data);
};

export const fetchVodPlayInfo = (videoId) => {
  return axios.get('/api/common/vod/playInfo/' + encodeURIComponent(videoId));
};

// 获取当前城市地区
export const fetchCurrentCity = (latitude, longitude) => {
  const amapKey = '你的高德地图Key';

  // 同时发起两个请求，谁先成功用谁
  const openStreetMapRequest = axios
    .get(`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`, { timeout: 8000 })
    .then((res) => ({
      address: {
        city:
          res.data.address?.city ||
          res.data.address?.town ||
          res.data.address?.village ||
          res.data.address?.state ||
          '',
      },
    }));

  // 如果有高德Key，同时发起高德请求
  const requests = [openStreetMapRequest];
  if (amapKey && amapKey !== '你的高德地图Key') {
    const amapRequest = axios
      .get(
        `https://restapi.amap.com/v3/geocode/regeo?key=${amapKey}&location=${longitude},${latitude}&extensions=base`,
        { timeout: 8000 }
      )
      .then((res) => {
        if (res.data && res.data.status === '1') {
          return {
            address: {
              city: res.data.regeocode.addressComponent.city || res.data.regeocode.addressComponent.province,
            },
          };
        }
        throw new Error('高德地图返回错误');
      });
    requests.push(amapRequest);
  }

  // 使用 Promise.race，谁先成功返回谁的结果
  return Promise.race(requests).catch(() => {
    // 如果race失败了，再等待任意一个成功
    return Promise.any(requests).catch(() => ({
      address: { city: '' },
    }));
  });
};

// 最快的方案：直接返回空，不调用任何外部服务
// export const fetchCurrentCity = (latitude, longitude) => {
//   return Promise.resolve({ address: { city: '' } });
// };
